import { types } from 'mobx-state-tree';
import { SpatialReference } from './spatialReference';

export const PolylineGeometry = types.model('PolylineGeometry', {
  gid: types.maybeNull(types.string),
  spatialReference: SpatialReference,
  paths: types.array(types.array(types.array(types.number)))
});
